import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ModalController } from "@ionic/angular";
import { CasteValVerificationListModel } from "src/app/model/CasteValVerificationListModel";
import { OfficialsService } from "src/app/services/officials.service";

@Component({
  selector: "app-secure-caste-val-verification-list",
  templateUrl: "./caste-val-verification-list.component.html",
  styleUrls: ["./caste-val-verification-list.component.scss"],
})
export class CasteValVerificationListComponent implements OnInit, AfterViewInit {
  page: Page<CasteValVerificationListModel>;
  letterList: Page<CasteValVerificationListModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  lotteryList: { [key: number]: string };
  schemeList: { [key: number]: string };
  dataSource: MatTableDataSource<CasteValVerificationListModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "applicantName",
    "lsct",
    "tenement",
    "warning",
    "status",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  filteredListParams: {
    lotteryEventId: number,
    schemeId: number,
    filterText: string
  };

  constructor(
    private officialsService: OfficialsService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    let storedFilter = localStorage.getItem("app-secure-letter-generate-filterText");
    // console.log('storedFilter', storedFilter);

    this.filterForm = new FormGroup({
      lottery: new FormControl(null, Validators.required),
      scheme: new FormControl(null),
      filterText: new FormControl(null, [Validators.minLength(3)]),
    });

    this.officialsService.initPage().subscribe((data: any) => {
      this.isLoading = false;
      if (data.status === "SUCCESS") {
        this.lotteryList = data.lotteryList;

        // if (storedFilter) {
        //   this.filteredListParams = JSON.parse(storedFilter);
        //   console.log('this.filteredListParams', this.filteredListParams);
        //   if (this.filteredListParams?.lotteryEventId) {
        //     let selectedLottery = this.lotteryList[this.filteredListParams.lotteryEventId];

        //     this.filterForm.patchValue({
        //       lottery: { key: this.filteredListParams?.lotteryEventId, value: selectedLottery }
        //       // filterText: this.filteredListParams?.filterText
        //     });
        //   }
        // }

        if (storedFilter) {
          this.filteredListParams = JSON.parse(storedFilter);
          // console.log('this.filteredListParams', this.filteredListParams);
          if (this.filteredListParams.lotteryEventId) {
            let selectedLottery = this.lotteryList[this.filteredListParams.lotteryEventId];

            this.filterForm.patchValue({
              lottery: { key: this.filteredListParams?.lotteryEventId, value: selectedLottery }
            });
            this.loadSchemes({ key: this.filteredListParams.lotteryEventId, value: selectedLottery }, () => {
              if (this.filterForm.valid) {
                let selectedScheme = this.filteredListParams?.schemeId ? this.schemeList[this.filteredListParams?.schemeId] : null;
                if(this.filteredListParams?.schemeId) {
                    this.filterForm.patchValue({
                      scheme: this.filteredListParams?.schemeId ? {key: this.filteredListParams?.schemeId, value: selectedScheme} : null,
                    });
                    this.onDataLoad();
                }
              }
            });
          }
        }
      }
      else {
        this.officialsService.errorToast(data.errorMessage);
      }
    }, (error) => {
      this.isLoading = false;
      this.officialsService.errorToast(error?.error?.errorMessage || error?.error?.message);
    }
    );


  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onDataLoad();
    }
    else {
      this._snackBar.open("Please Select Mandatory fields", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    localStorage.removeItem("app-secure-letter-generate-filterText");
    this.ngOnInit();
  }

  removeSearchedListAndSavedFilter() {
    this.filteredListParams = null;
    localStorage.removeItem("app-secure-letter-generate-filterText");
    this.letterList = null;
    this.dataSource = null;
    this.paginator.pageIndex = 0;
    this.paginator.length = 0;
  }


  loadSchemes(lottery: { key: number, value: string }, callback) {
    this.schemeList = {};
    if (!callback) {
      this.removeSearchedListAndSavedFilter();
    }
    if (lottery?.key) {
      this.isLoading = true;
      this.onDataLoad();
      this.officialsService.fetchSchemeForLotteryEvent(lottery?.key).subscribe((data: any) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.schemeList = data.schemeList;

        if (callback) {
            callback();
          }
        }
        else {
          this.officialsService.errorToast(data.errorMessage);
        }
      }, (error) => {
        this.isLoading = false;
        this.officialsService.errorToast(error?.error?.errorMessage || error?.error?.message);
      }
      );
    }
  }

  loadData(scheme: { key: number, value: string }, callback) {
    if (!callback) {
      this.removeSearchedListAndSavedFilter();
    }

    if (scheme?.key) {
      // this.isLoading = true;
      // this.filteredListParams.schemeId = scheme?.key;
      this.onDataLoad();
    }
  }

  onDataLoad() {
    this.isLoading = true;
    this.isSearchDisabled = true;
    this.filteredListParams = {
      lotteryEventId: this.filterForm.value?.lottery?.key,
      schemeId: this.filterForm.value?.scheme?.key,
      filterText: this.filterForm.value?.filterText
    };
    localStorage.setItem("app-secure-letter-generate-filterText", JSON.stringify(this.filteredListParams));

    // console.log('SCHEME JSON => ',JSON.stringify(this.filteredListParams));

    this.officialsService.fetchApplicationListForLetterType(  
      this.currentPage,
      this.pageSize,
      this.filterForm.value?.lottery?.key,
      this.filterForm.value?.scheme?.key,
      this.filterForm.value?.filterText

    ).subscribe((data) => {
      
      if (data.status === 'SUCCESS') {
        // console.log(data);
        this.letterList = data.data;
        this.dataSource = new MatTableDataSource(data.data.content);

        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = data.data.totalElements;
        });

        this.isSearchDisabled = false;
        this.isLoading = false;
      }
      else {
        this.officialsService.errorToast(data.errorMessage);
      }
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.isSearchDisabled = false;
      this.officialsService.errorToast(error?.error?.errorMessage || error?.errorMessage);
    }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onDataLoad();
  }

  viewClassForLetterStatus(letterStatus: string) {
    if (letterStatus === 'UNSIGN_ALLOTMENT_GENERATED' || letterStatus === 'UNSIGN_POSSESSION_GENERATED') {
      return 'bg-blue-400';
    }
    else if (["DRAW_WINNER", "DRAW_WAITLIST_ACTIVATED"].indexOf(letterStatus) >= 0) {
      return 'bg-green-400';
    }
    else if (["LOI_NOT_PUBLISHED", "DRAW_WINNER_SURRENDERED",
      "DRAW_WAITLIST_SURRENDERED", "DRAW_WINNER_OPERATED", "DRAW_WAITLIST_OPERATED"].indexOf(letterStatus) >= 0) {
      return 'bg-pink-600';
    }
    else {
      return '';
    }
  }

  showBDD(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  showObj(o1: any, o2: any) {
    // console.log('showObj', o1, o2, o1 == o2);
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

}